import React from 'react';
import { Radio } from 'react-form';
import InfoButton from '../../InfoButton';
import Img from '../../Img';

const RadioButton = (props) => {
    const {
        id,
        label,
        description,
        value,
        disabled,
        hoverText,
        onChange,
        controlled,
        buttonTag,
        'data-testid': dataTestId,
        ...rest
    } = props;

    return (
        <div
            className={`radio-button noselect ${disabled ? 'disabled' : ''}`}
            data-testid={dataTestId || undefined}
            onChange={(ev) => {
                if (onChange) {
                    onChange(ev);
                }
            }}
        >
            {!controlled ? (
                <Radio
                    id={id}
                    value={value}
                    disabled={disabled}
                    data-testid={dataTestId && `${dataTestId}.input`}
                    {...rest}
                />
            ) : (
                <input
                    type="checkbox"
                    id={id}
                    value={value}
                    disabled={disabled}
                    data-testid={dataTestId && `${dataTestId}.input`}
                    {...rest}
                />
            )}
            <label htmlFor={id}>
                <div className="radio-button-check" data-testid={dataTestId && `${dataTestId}.check-icon`}><Img src="/img/icons/checkmark-icon.svg" /></div>
                <div className="radio-button-label">
                    <div className="d-flex justify-content-between align-items-baseline">
                        <span data-testid={dataTestId && `${dataTestId}.label`}>
                            {label}
                            {hoverText && <InfoButton hoverText={hoverText} />}
                        </span>
                        {buttonTag && <div className="badge tag-teal" data-testid={dataTestId && `${dataTestId}.tag`}>{buttonTag}</div>}
                    </div>
                    <div className="radio-button-description" data-testid={dataTestId && `${dataTestId}.description`}>{description}</div>
                </div>
            </label>
        </div>
    );
};

RadioButton.defaultProps = {
    controlled: false,
    'data-testid': null,
};

export default RadioButton;
